export default __webpack_public_path__ + "static/media/ritualofthelich.c8c3043e.png";